<div class="survey-wrapper">
    <div class="banner">
        <picture>
            <source media="(min-width: 1024px)" srcset="../assets/images/survey-banner-vertical.jpg">
            <source media="(max-width: 1024px)" srcset="../assets/images/survey-banner-horizontal.jpg">
            <img src="../assets/images/survey-banner-vertical.jpg" alt="banner">
        </picture>
    </div>      
    <div class="content">
        <div *ngIf="isMaintenance; else normalContent" class="main-section" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2%">
            <h1>系統維護中，請您於 {{maintenanceEndTimeFormatted}} 後再次前往填寫</h1>
        </div>
        <ng-template #normalContent>
            <router-outlet></router-outlet>
        </ng-template>
    </div>
<div>
